import { ECategory, IOffer } from 'shared/types/offers';

export const isDailyrentOffer = ({ category }: Pick<IOffer, 'category'>) => {
  return [ECategory.DailyBedRent, ECategory.DailyRoomRent, ECategory.DailyHouseRent, ECategory.DailyFlatRent].includes(
    category,
  );
};
